export interface ProductSummary {
  cprcode: string;
  display_name: string;
  brand: string;
  category: string;
  seo_score: number;
  is_selling: boolean;
  has_translations: {
    th: boolean;
    fr: boolean;
    de: boolean;
    zh: boolean;
    ru: boolean;
  };
  written_at: string;
  review_status: ReviewStatus;
}

export type ReviewStatus = 'pending' | 'approved' | 'changes_requested' | 'denied' | '';

export interface ProductDetail {
  cprcode: string;
  display_name: string;
  brand: string;
  category: string;
  size: string;
  upc_description: string;
  review_status: ReviewStatus;
  review_by: string;
  review_at: number;
  review_note: string;
  // English
  short_description_en: string;
  long_description_en: string;
  content_en: string;
  meta_title: string;
  meta_description: string;
  meta_keywords: string;
  schema_jsonld: string;
  // Thai
  display_name_th: string;
  short_description_th: string;
  long_description_th: string;
  content_th: string;
  meta_title_th: string;
  meta_description_th: string;
  // French
  short_description_fr: string;
  long_description_fr: string;
  meta_title_fr: string;
  meta_description_fr: string;
  // German
  short_description_de: string;
  long_description_de: string;
  meta_title_de: string;
  meta_description_de: string;
  // Chinese
  short_description_zh: string;
  long_description_zh: string;
  meta_title_zh: string;
  meta_description_zh: string;
  // Russian
  short_description_ru: string;
  long_description_ru: string;
  meta_title_ru: string;
  meta_description_ru: string;
  // Original ground truth
  original_content_en: string;
  original_content_th: string;
  // Computed
  seo_score: number;
  is_selling: boolean;
  has_th: boolean;
  has_fr: boolean;
  has_de: boolean;
  has_zh: boolean;
  has_ru: boolean;
  // Metadata
  written_at: string;
  writer: string;
  loaded_at: string;
}

export interface DashboardStats {
  total_products: number;
  avg_seo_score: number;
  score_distribution: Record<string, number>;
  selling_count: number;
  not_selling_count: number;
  top_categories: Array<{ name: string; count: number }>;
  top_brands: Array<{ name: string; count: number }>;
  languages_coverage: Record<string, number>;
  review_stats: Record<string, number>;
  recent_edits: Array<{
    cprcode: string;
    display_name: string;
    user: string;
    timestamp: string;
    fields: string[];
  }>;
}

export interface ProductListResponse {
  products: ProductSummary[];
  last_key?: string;
  count: number;
}

export interface ProductComment {
  comment_id: string;
  user: string;
  text: string;
  timestamp: number;
  cprcode: string;
}

export type Language = 'en' | 'th' | 'fr' | 'de' | 'zh' | 'ru';

export const LANGUAGES: { code: Language; name: string; flag: string }[] = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'th', name: 'Thai', flag: '🇹🇭' },
  { code: 'fr', name: 'French', flag: '🇫🇷' },
  { code: 'de', name: 'German', flag: '🇩🇪' },
  { code: 'zh', name: 'Chinese', flag: '🇨🇳' },
  { code: 'ru', name: 'Russian', flag: '🇷🇺' },
];
